import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './OccurrenceFormDialog.html?raw';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/GenericDialog/GenericDialog";
import OccurrenceForm from '../OccurrenceForm/OccurrenceForm';
import "../OccurrenceForm/OccurrenceForm";
import "../../../moreCore/UI/Toaster_TS/Toaster";

class OccurrenceFormDialog_XXX extends compose(_WidgetBaseSP) {
    templateString: any = template;

    dialog: MdsLax<InstanceType<typeof GenericDialog>>;
    occurrenceForm: MdsLax<InstanceType<typeof OccurrenceForm>>;

    _submitInProgess: boolean = false;

    _isCancelAvailable: boolean = false;
    editToastUUID: Function;

    _request: any = null;
    entity: Occurrence.OccurenceEntity = null;
    private entityGUID: string = null;

    ticketCancellationNote: string = "";

    


    showErrorDetailsDlg(message, header, subtitle, buttons, callback) {
        let dlg = new GenericDialog();
        dlg.show(message, header, subtitle, null, buttons, callback);
    }

    // -------------------------- MESSAGES ------------------- END


    /// ----------------------- cancellation process----------------------for the future eventually ---- START

    setIsCancelEnabled(): void {
        /* 
         evaluates, if the cancel btn shoold be enbaled or not, based on parameters which should be generic
         */

        //if (this.employee != null) {
        //    if (jsonEntity.ref_reporter.ID == this.employee.ID) {
        //        this._isCancelAvailable++;
        //    }
        //}

        //if (jsonEntity.ref_occurrence_status.is_cancel_request_enabled == true) {
        //    this._isCancelAvailable++;
        //}

        //if (jsonEntity.is_cancellation_requested != true) {
        //    this._isCancelAvailable++;
        //}
    }

    setCancelRequestBtnStyle(): void {
        /*
         enables/disables the cancel button
         */

        this.setIsCancelEnabled();

        var fct1: Function = this.UiModder.domClass.add;
        var fct2: Function = this.UiModder.domClass.remove;

        if (this._isCancelAvailable) {
            fct1 = this.UiModder.domClass.remove;
            fct2 = this.UiModder.domClass.add;
        }

        //fct1(this.btn_cancelTicket, "w3-disabled"); // elts see hpw we do it

    }

    _onClick_CancelTicket(evt) {

        /*
         * this function is currently not used
         * 
         if cancellation is available, creates a new generic dialog for confirmation, 
         if the pushed button is yes (result 2), a request shall be maid
         */


        if (!this._isCancelAvailable) return;

        var dlg: MdsLax<InstanceType<typeof GenericDialog>> = new GenericDialog;

        dlg.destroyOnClose = true;

        dlg.set("header", this.translations["OccurrenceForm__DialogCancelTicketHeader"]);
        dlg.set("SubTitle", this.translations["OccurrenceForm__DialogCancelTicketSubtitle"]);

        dlg._setYesBtnAttr(true);
        dlg._setNoBtnAttr(true);
        dlg._setTopCloseBtnAttr(true);

        let cancellationNote: HTMLTextAreaElement = <HTMLTextAreaElement>this.UiModder.domConstruct.create("textarea");
        this.UiModder.domClass.add(cancellationNote, "w3-input w3-block");
        dlg.addNodeToContent(cancellationNote);

        // verhinden dass mit "Enter" der Dialog beendet wird
        on(cancellationNote, "keyup", function (evt) {
            evt.stopPropagation();
            this.ticketCancellationNote = (<HTMLTextAreaElement>cancellationNote).value;
        });

        on(dlg, "closed", lang.hitch(this, function (closingResult: { result: number }) {
            if (closingResult.result == 2) { // 2 for "yes"
                this._cancelTicket();
            }
        }))

        dlg.show();
    }

    private _cancelTicket() {

        /*
         * currently not used
         */

        if (!this._isCancelAvailable) return;

        
        var url: string = window.appRoot + "Eforms/RequestCancellation";

        this._request = this.RequestManager.callfunction(
            "Webtool_Occurrence_API__CancelOccurrence",
            {
                note: this.ticketCancellationNote,
                occurrenceID: this.entity.ID,
            },
            lang.hitch(this, "_onRequestCancelTicketResponse"), // reloads the form
            lang.hitch(this, "_onRequestCancelTicketError"), // show error message
        );
    }

    /// ----------------------- cancellation process----------------------for the future eventually ---- END

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(OccurrenceFormDialog_XXX);